import React, {Fragment, useState} from "react";
import {FormattedMessage} from "react-intl";
import {Route, Switch, withRouter} from "react-router-dom";

import LookLoginButton from "./lookLoginButton";
import LookUserInputs from "./lookUserInputs";
import LookRegisterCheckboxes from "./lookRegisterCheckboxes";
import LookRegisterButton from "./lookRegisterButton";
import {ROUTES} from "../../../routes";

const LookUserContent = (props) => {

  const {history, popupClose} = props;
  const [inputsValidated, setInputsValidated] = useState(true);

  const updateInputValidations = () => {
    setInputsValidated(false);
    return new Promise((resolve) => {
      setTimeout(() => {
        setInputsValidated(false);
        resolve()
      }, 300); // wait until redux store is updated with input Errors
    });
  };


  const forgotButtonClick = () => {

  }

  const signUpButtonClick = () => {
    history.push("register");
  }

  return (
    <div className="ll-user__right">
      <div className="ll-user__right-content">
        <h1 className="h1">
          <Switch>
            <Route path={ROUTES.login}>
              <FormattedMessage id="look.login.title"/>
            </Route>
            <Route path={ROUTES.register}>
              <FormattedMessage id="look.register.title"/>
            </Route>
          </Switch>
        </h1>
        <LookUserInputs inputsValidated={inputsValidated}/>
        <Switch>
          <Route path={ROUTES.login}>
            <Fragment>
              <p>
                <span className="look-tertiary look-link" onClick={forgotButtonClick}>
                  <FormattedMessage id="look.login.forgotPassword"/>
                </span>
              </p>
              <LookLoginButton popupClose={popupClose}/>
              <p className="look-primary">
                <FormattedMessage id="look.login.noAccount"/> <span className="look-link look-link--bold" onClick={signUpButtonClick}>
                  <FormattedMessage id="look.login.registerLink"/>
                </span>
              </p>
            </Fragment>
          </Route>
          <Route path={ROUTES.register}>
            <Fragment>
              <LookRegisterCheckboxes/>
              <LookRegisterButton updateInputValidations={updateInputValidations} popupClose={popupClose}/>
            </Fragment>
          </Route>
        </Switch>
      </div>
    </div>
  )
};

export default withRouter(LookUserContent)
